<template>
    <v-container>
        <h1>Contactanos</h1>
    </v-container>
</template>

<script>
export default {
    name: 'Contactanos',
    components: {

    }
    
}
</script>

<style scoped lang="sass">

</style>